
    import CardQuicklink from "@/features/dashboard/components/CardQuicklink.vue";
    import HeadingWave from "@/features/shared/components/HeadingWave.vue";
    import Component from "vue-class-component";
    import Vue from "vue";
    import {
        ApplicationsListActions,
        ApplicationsListClient,
        ApplicationState, OfficialApplicationLightViewModel,
        SeafarerApplicationLightViewModel, SysAdminOrganizationsClient
    } from "@/api-client";
    import ApplicationStateBadge from "@/features/applications/components/ApplicationStateBadge.vue";
    import translateApplicationState from "@/features/applications/components/ApplicationStateTranslator";
    import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
    import {Prop} from "vue-property-decorator";
    import {Route} from "vue-router";
    import ClientsidePaging from "@/components/ClientsidePaging";
    import NewCertificateCard from "@/features/applications/components/new-application/NewCertificateCard.vue";
    import NewEndorsementCard from "@/features/applications/components/new-application/NewEndorsementCard.vue";
    import NewDuplicateCard from "@/features/applications/components/new-application/NewDuplicateCard.vue";
    import userInfo from "@/features/shared/components/UserInfo";
    import {translateTrueFalse} from "@/features/shared/TrueFalseTranslator";
    import {formatDate} from "@/formatting/dateFormatter";
    import {NavigationGuardNext} from "vue-router/types/router";
    import SeafarerDashboardApplicationTable from "@/features/dashboard/components/SeafarerDashboardApplicationTable.vue";
    import ClientsidePagingSelector from "@/components/ClientsidePagingSelector.vue";

    interface Props {
        applications: SeafarerApplicationLightViewModel[];
        actions: ApplicationsListActions;
    }

    @Component({
        components: {
            CardQuicklink,
            HeadingWave,
            ApplicationStateBadge,
            TableEmptySlot,
            NewCertificateCard,
            NewEndorsementCard,
            NewDuplicateCard,
            SeafarerDashboardApplicationTable,
            ClientsidePagingSelector
        },
        beforeRouteEnter(to, from, next: NavigationGuardNext<SeafarerDashboard>) {
            const props = to.meta!.props;
            Promise.all([
                new ApplicationsListClient().availableActions(),
                new ApplicationsListClient().seafarer([])
            ]).then(values => {
                props.actions = values[0];
                props.applications = values[1];
                next();
            }).catch(e => next(e))
        }
    })
    export default class SeafarerDashboard extends Vue implements Props {
        @Prop({required: true})
        applications!: SeafarerApplicationLightViewModel[];
        @Prop({required: true})
        actions!: ApplicationsListActions;

        userInfo = userInfo;
        paging = new ClientsidePaging();
    }
